module.exports = __webpack_public_path__ + "media/images/parallax/illustration-connect-background-98d72b39c0104d4e1a7dc2bd06fb4c75.png";